import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Beteiligten Erstellen")
const _hoisted_2 = { class: "w-full h-full max-h-screen flex flex-col justify-between px-4 pb-4" }
const _hoisted_3 = { class: "w-full h-full pt-4 flex flex-col overflow-y-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Funktion*:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Name*:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Land*:", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("DE")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("AT")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("CH")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("LU")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("NL")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Ort*:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "PLZ*:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Straße*:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Hausnummer*:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "E-Mail*:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Mobil:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Telefon:", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold mt-2" }, "Fax:", -1)

import { IonPage, IonHeader, IonContent, IonToolbar, IonButtons, IonBackButton, alertController, IonTitle, modalController, IonSelect, IonSelectOption } from '@ionic/vue'
import { ref } from 'vue'
import axios from 'axios'
import CreateSubcustomerDto from '@/interfaces/subcustomer/CreateSubcustomerDto';
import { useCompany } from '@/store/company';
import { useType } from '@/store/type'
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubcustomerProjectPage',
  setup(__props) {

const typeStore = useType()
const companyStore = useCompany()
const currentUserStore = useCurrentUser()

const subcustomerData = ref({} as CreateSubcustomerDto)

async function dismiss() {
  await modalController.dismiss()
}

async function saveSubcustomer() {
  if(subcustomerData.value.name == "" 
  || subcustomerData.value.function_id == "" 
  || subcustomerData.value.country == "" 
  || subcustomerData.value.city == "" 
  || subcustomerData.value.zip == "" 
  || subcustomerData.value.email == ""
  || subcustomerData.value.street == ""
  || subcustomerData.value.no == ""
  ) {
    const alert = await alertController.create({
      header: 'Fehler',
      message: 'Bitte füllen Sie alle Felder aus.',
      buttons: ['OK']
    })
    return alert.present()
  }

  try {
    const response = await axios.post(process.env.VUE_APP_CUSTOMER_API_BASE_URL + "subcustomer", subcustomerData.value + "/?company_id=" + companyStore.activeCompany.id, {
      headers: {
        Authorization: 'Bearer ' + currentUserStore.jwtKey
      }
    })
    await modalController.dismiss(response.data.data._id)
  } catch (e: any) {
    const alert = await alertController.create({
      message: e.response.status + ': Unerwarteter Fehler',
      buttons: ['OK']
    })
    return alert.present()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    text: "",
                    style: {"--color":"#444444"},
                    "default-href": "/addProject",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (dismiss()))
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(IonSelect), {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                modelValue: subcustomerData.value.function_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subcustomerData.value.function_id) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).functionTypes, (func, index) => {
                    return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                      value: func.value,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(func.titel), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subcustomerData.value.name) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.name]
              ]),
              _hoisted_6,
              _createVNode(_unref(IonSelect), {
                enterkeyhint: "next",
                interface: "popover",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                modelValue: subcustomerData.value.country,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((subcustomerData.value.country) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSelectOption), null, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), null, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((subcustomerData.value.city) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.city]
              ]),
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((subcustomerData.value.zip) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.zip]
              ]),
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((subcustomerData.value.street) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.street]
              ]),
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((subcustomerData.value.no) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.no]
              ]),
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((subcustomerData.value.email) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.email]
              ]),
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((subcustomerData.value.mobile) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.mobile]
              ]),
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((subcustomerData.value.phone) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.phone]
              ]),
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                enterkeyhint: "next",
                class: "w-full min-h-10 my-1 bg-zewotherm-lightgrey border p-2 font-bold rounded-lg outline-none",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((subcustomerData.value.fax) = $event))
              }, null, 512), [
                [_vModelText, subcustomerData.value.fax]
              ])
            ]),
            _createElementVNode("button", {
              style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (saveSubcustomer())),
              class: "w-full min-h-10 text-white font-bold rounded-lg cursor-pointer mt-3 active:scale-95 duration-200"
            }, "Anlegen", 4)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})